import { Injectable } from '@angular/core';
import { AppSettingsService } from '../appSettings/AppSettingsService';
import { IMaxIntValueService } from '../config/typings/services';

@Injectable({
    providedIn: 'root'
})
export class MaxIntValueService implements IMaxIntValueService {
    public static $name: string = 'maxIntValueService';

    constructor(
        private appSettingsService: AppSettingsService
    ) {
    }

    public getMaxIntValue() {
        let metadata = this.appSettingsService.getMetadata();

        return metadata.maxIntValue;
    }
}
